import depo from './depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import { secimVarMi } from './satinAlSecim';
import { reactive } from 'vue';
import { Servis } from './Servis';

// SK3-Y/M (SaglayiciKonsolu/KONSOL-V3 planı §4): konsol menüsünün TEK tanımı. Grup anahtarı =
// BE yetki anahtarı (Helpers/SistemAlan.cs) = Sparqon alanı. Aynı liste üç yerde kullanılır:
// SistemLayout menüsü, Ctrl+K arama ve router guard (rotaAlani — en uzun önek eşleşmesi).
// Yeni bir /sistem sayfası eklerken buraya bir öğe (ya da ekYollar'a önek) eklemek yeterli;
// eşleşmeyen /sistem rotası "pano" sayılır (yetkisi herkeste).
export const SISTEM_MENU = [
  {
    anahtar: 'pano', ad: 'Pano', ikon: 'pi pi-th-large',
    ogeler: [{ ad: 'Genel', url: '/sistem/genel', ikon: 'pi pi-home' }],
  },
  {
    anahtar: 'sirketler', ad: 'Şirketler', ikon: 'pi pi-building',
    ogeler: [
      { ad: 'Şirketler', url: '/sistem/sirketler', ikon: 'pi pi-building' },
      { ad: 'Yeni şirket', url: '/sistem/sirketler/yeni', ikon: 'pi pi-plus-circle' },
      { ad: 'Demo talepleri', url: '/sistem/sirketler/demo-talepler', ikon: 'pi pi-inbox' },
      { ad: 'Duyurular', url: '/sistem/duyurular', ikon: 'pi pi-megaphone' },
    ],
  },
  {
    anahtar: 'satis', ad: 'Satış', ikon: 'pi pi-shopping-bag',
    ogeler: [
      { ad: 'Paketler', url: '/sistem/urun/paketler', ikon: 'pi pi-box' },
      { ad: 'Ekler', url: '/sistem/urun/ekler', ikon: 'pi pi-plus-circle' },
      { ad: 'İndirimler', url: '/sistem/urun/indirimler', ikon: 'pi pi-percentage' },
      { ad: 'Vitrin önizleme', url: '/sistem/urun/onizleme', ikon: 'pi pi-eye' },
      { ad: 'Siparişler', url: '/sistem/siparisler', ikon: 'pi pi-shopping-cart' },
      { ad: 'Gelir', url: '/sistem/gelir', ikon: 'pi pi-chart-line' },
      { ad: 'Lisans tanımları', url: '/sistem/lisans/tanim', ikon: 'pi pi-id-card' },
      { ad: 'Lisans-sayfa atama', url: '/sistem/lisans/sayfa', ikon: 'pi pi-key' },
    ],
  },
  {
    anahtar: 'destek', ad: 'Destek', ikon: 'pi pi-headphones',
    ogeler: [
      // SK4-Ç2: sağlayıcının çağrıları konsolda (eskiden panel /cagri/cagrilistesi — "Panele geç").
      { ad: 'Çağrılar', url: '/sistem/destek/cagrilar', ikon: 'pi pi-ticket' },
      { ad: 'Uyarılar', url: '/sistem/uyarilar', ikon: 'pi pi-bell' },
      { ad: 'Çağrı kategorileri', url: '/sistem/destek/kategoriler', ikon: 'pi pi-tags' },
      { ad: 'Hizmet seviyesi (SLA) kuralları', url: '/sistem/destek/sla', ikon: 'pi pi-stopwatch' },
      { ad: 'Yardım yönetimi', url: '/sistem/yardim', ikon: 'pi pi-question-circle' },
      { ad: 'Güncellemeler', url: '/sistem/guncellemeler', ikon: 'pi pi-history' },
    ],
  },
  {
    anahtar: 'whatsapp', ad: 'WhatsApp', ikon: 'pi pi-whatsapp',
    ogeler: [
      { ad: 'Havuz numaraları', url: '/sistem/whatsapp/havuz', ikon: 'pi pi-phone' },
      { ad: 'Global şablonlar', url: '/sistem/whatsapp/sablonlar', ikon: 'pi pi-file-edit' },
      { ad: 'Kota raporu', url: '/sistem/whatsapp/kota', ikon: 'pi pi-chart-bar' },
      { ad: 'HepyApp hattı · Numaralar', url: '/sistem/whatsapp/hat/numaralar', ikon: 'pi pi-mobile' },
    ],
  },
  {
    // SKB-E3 (SAGLAYICI-KANAL-PLANI.md K8): HepyApp'in kendi WhatsApp hattı + Telegram botu ortak ekranları.
    // Ayrı yetki alanı YOK — yetkiAlan: 'whatsapp' (rol ekranlarında ayrı grup olarak görünmez).
    anahtar: 'kanallar', yetkiAlan: 'whatsapp', ad: 'HepyApp kanalları', ikon: 'pi pi-send',
    ogeler: [
      { ad: 'Kanallar', url: '/sistem/kanallar/ayar', ikon: 'pi pi-sliders-h' },
      { ad: 'Loglar', url: '/sistem/kanallar/loglar', ikon: 'pi pi-list' },
      { ad: 'Asistan profili (WhatsApp)', url: '/sistem/kanallar/asistan', ikon: 'pi pi-sparkles' },
      { ad: 'Engel listesi', url: '/sistem/kanallar/engel', ikon: 'pi pi-ban' },
      { ad: 'Yasaklı kelime', url: '/sistem/kanallar/yasakli', ikon: 'pi pi-eye-slash' },
    ],
  },
  {
    anahtar: 'sparqon', ad: 'Sparqon', ikon: 'pi pi-comments',
    ogeler: [
      { ad: 'Loglar ve kalite', url: '/sistem/sparqon/log', ikon: 'pi pi-comments' },
      { ad: 'Ayarlar', url: '/sistem/sparqon/ayar', ikon: 'pi pi-sliders-h' },
      { ad: 'Yetenekler', url: '/sistem/sparqon/yetenek', ikon: 'pi pi-bolt' },
    ],
  },
  {
    // IZ-K (SaglayiciKonsolu/ISTATISTIK-VE-IZLEME-PLANI.md V1): GA/GSC/CWV + kullanım + performans + NPS.
    anahtar: 'istatistik', ad: 'İstatistik', ikon: 'pi pi-chart-line',
    ogeler: [
      { ad: 'Trafik', url: '/sistem/istatistik/trafik', ikon: 'pi pi-globe' },
      { ad: 'Kullanım', url: '/sistem/istatistik/kullanim', ikon: 'pi pi-users' },
      { ad: 'Performans', url: '/sistem/istatistik/performans', ikon: 'pi pi-gauge' },
      { ad: 'NPS', url: '/sistem/istatistik/nps', ikon: 'pi pi-star' },
    ],
  },
  {
    anahtar: 'operasyon', ad: 'Operasyon', ikon: 'pi pi-server',
    ogeler: [
      { ad: 'Sistem durumu', url: '/sistem/durum', ikon: 'pi pi-server' },
      { ad: 'Görevler', url: '/sistem/joblar', ikon: 'pi pi-clock' },
      { ad: 'Veritabanı yedekleri', url: '/sistem/yedekler', ikon: 'pi pi-database' },
      { ad: 'Servis log', url: '/sistem/servis-log', ikon: 'pi pi-list' },
      { ad: 'SQL olay logu', url: '/sistem/sql-olay', ikon: 'pi pi-shield' },
      { ad: 'Hata kuralları', url: '/sistem/ayarlar/hatakural', ikon: 'pi pi-exclamation-triangle' },
      { ad: 'Mail şablon testi', url: '/sistem/ayarlar/mailsablon', ikon: 'pi pi-envelope' },
      { ad: 'Tablo boyutları', url: '/sistem/ayarlar/tabloboyut', ikon: 'pi pi-table' },
      { ad: 'Dış besin kataloğu', url: '/sistem/ayarlar/besinkatalogu', ikon: 'pi pi-apple' },
      { ad: 'Entegrasyonlar', url: '/sistem/entegrasyonlar', ikon: 'pi pi-link' },
      { ad: 'Kullanım raporları', url: '/sistem/raporlar', ikon: 'pi pi-chart-bar' },
    ],
  },
  {
    anahtar: 'yetki', ad: 'Yetki', ikon: 'pi pi-lock',
    ogeler: [
      { ad: 'Konsol kullanıcıları', url: '/sistem/yetki/kullanicilar', ikon: 'pi pi-users' },
      { ad: 'Konsol rolleri', url: '/sistem/yetki/roller', ikon: 'pi pi-shield' },
      { ad: 'Denetim kaydı', url: '/sistem/yetki/denetim', ikon: 'pi pi-history' },
      { ad: 'Modül yetki filtresi', url: '/sistem/yetki/filtre', ikon: 'pi pi-filter' },
      { ad: 'Yetki yerleri', url: '/sistem/yetki/yetkiyeri', ikon: 'pi pi-sitemap' },
      { ad: 'Web sayfaları', url: '/sistem/yetki/websayfa', ikon: 'pi pi-file' },
      { ad: 'Rol yetkileri (kiracı)', url: '/sistem/yetki/rolyetki', ikon: 'pi pi-id-card' },
    ],
  },
];

// Menüde öğesi olmayan ama bir gruba ait yollar (sayfa içi düğmelerle açılanlar).
const EK_YOLLAR = {
  '/sistem/urun': 'satis',
  '/sistem/raporlar/whatsapp': 'whatsapp',
  '/sistem/destek': 'destek', // çağrı detayı, kategori yeni/düzenle
  '/sistem/istatistik': 'istatistik', // IZ-K: grup kökü (ileride alt sayfa/derin bağlantı)
  // /sistem/hesap bilerek yok → "pano" (kişisel ayar, her konsol kullanıcısına açık).
};

// Grubun yetki alanı (BE SistemAlan) — yetkiAlan'lı gruplar başka bir alanın yetkisini paylaşır.
export const grupAlani = (g) => g.yetkiAlan || g.anahtar;
// Rol/denetim ekranları: yalnız kendi yetki alanı olan gruplar.
export const YETKI_GRUPLARI = SISTEM_MENU.filter((g) => !g.yetkiAlan);

export const ALAN_ADLARI = Object.fromEntries(YETKI_GRUPLARI.map((g) => [g.anahtar, g.ad]));

// Guard/menü/Sparqon'un okuduğu tek reaktif durum (uiState emsali — Vuex'e gerek yok).
export const sistemKonsol = reactive({
  erisim: false,
  anahtarlar: [],
  rolAd: null,
  yetkisizUyari: null, // guard, izinsiz bölüme gidişi panoya çevirince SistemLayout toast gösterir
  yuklendi: false, // SK4-G: panel rotasında konsol yetkisi oturum (token) başına bir kez sorulur
  token: null, // yuklendi'nin ait olduğu token — oturum yenilenince/değişince önbellek bayatlar
  panelUyari: null, // SK4-G: panel adresi konsola çevrilince SistemLayout bilgi toast'ı gösterir
});

// SK4-G (KONSOL-V4 K2/K7): sağlayıcı ekibi kiracı panelini kullanmaz. Panel rotası → konsol karşılığı
// (eski çağrı linkleri, kullanıcı ayarları) ya da konsol panosu. null = panelde kalabilir (yardım sayfası).
const PANEL_SERBEST = ['/yardim/genelyardimsayfasi'];
export function saglayiciPanelHedefi(to) {
  const p = (to.path || '').toLowerCase().replace(/\/+$/, '');
  if (PANEL_SERBEST.some((s) => p === s || p.startsWith(s + '/'))) return null;
  const cagriNo = to.query && to.query.CagriNo;
  if ((p === '/cagri/duzenlecagri' || p === '/cagri/detaycagri' || p === '/yardimmasa/duzenlecagri') && cagriNo) {
    return { path: '/sistem/destek/cagri', query: { CagriNo: cagriNo } };
  }
  if (p.startsWith('/cagri')) return { path: '/sistem/destek/cagrilar' };
  if (p === '/kullanici/ayarlar' || p === '/kullanici') return { path: '/sistem/hesap' };
  return { path: '/sistem/genel' };
}

// Rotanın menü grubu (anahtar) — menüde hangi grubun açık/aktif olacağı.
export function rotaGrubu(path) {
  const p = (path || '').toLowerCase().replace(/\/+$/, '');
  if (!p.startsWith('/sistem')) return null;
  let enIyi = null;
  let enUzun = -1;
  const dene = (onek, alan) => {
    const o = onek.toLowerCase();
    if ((p === o || p.startsWith(o + '/')) && o.length > enUzun) { enIyi = alan; enUzun = o.length; }
  };
  SISTEM_MENU.forEach((g) => g.ogeler.forEach((o) => { if (!o.panel) dene(o.url, g.anahtar); }));
  Object.entries(EK_YOLLAR).forEach(([o, a]) => dene(o, a));
  return enIyi || 'pano';
}

// Rotanın yetki alanı — guard ve Sparqon bununla bakar.
export function rotaAlani(path) {
  const grup = rotaGrubu(path);
  if (!grup) return null;
  const g = SISTEM_MENU.find((x) => x.anahtar === grup);
  return g ? grupAlani(g) : grup;
}

export function alanVar(alan) {
  return !alan || alan === 'pano' || sistemKonsol.anahtarlar.includes(alan);
}

// GetSistemKonsolErisim → durum. Dönüş: ham yanıt (guard 401/403'e bakar).
export async function konsolYetkisiYukle() {
  const res = await Servis('GET', 'GetSistemKonsolErisim', '');
  const d = res && res.status === 200 && res.data && typeof res.data === 'object' ? res.data : null;
  sistemKonsol.erisim = !!(d && d.Erisim === true);
  sistemKonsol.anahtarlar = sistemKonsol.erisim && Array.isArray(d.Anahtarlar) ? d.Anahtarlar : [];
  sistemKonsol.rolAd = sistemKonsol.erisim ? d.RolAd : null;
  // Yalnız gerçek yanıt önbelleğe girer: 401 (süresi dolmuş oturum) "erişim yok" olarak kalıcılaşırsa
  // yeniden girişten sonra sağlayıcı panelde kalıp /hata-erisim-yetkisi döngüsüne düşüyordu.
  sistemKonsol.yuklendi = !!d;
  sistemKonsol.token = d ? depo.oku('token') : null;
  return res;
}

// SK4-G guard: önbellek bu oturumun token'ına mı ait?
export function konsolYetkisiGuncelMi() {
  return sistemKonsol.yuklendi && sistemKonsol.token === depo.oku('token');
}

// K2/V8: girişten sonra nereye — sağlayıcı kullanıcısı konsol panosuna, diğerleri panele.
// Hata/ağ sorununda panel (fail-safe: konsol zaten kendi guard'ında tekrar sorar).
export async function girisSonrasiRota() {
  try {
    const res = await konsolYetkisiYukle();
    if (res && res.status === 200 && res.data && res.data.Erisim === true) {
      return res.data.VarsayilanRota || '/sistem/genel';
    }
  } catch (e) { /* panel */ }
  // SAT-5: hepy.app fiyat sayfasından seçimle gelindiyse doğrudan Satın Al (seçim hazır).
  if (secimVarMi()) return '/lisans/satinal';
  return '/admin/main';
}
